export default class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
    public readonly response: Response
  ) {
    super(`HTTP ${status}`)
    this.name = 'HttpError'
  }
}
